
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/forgot",
      function () {
        return require("private-next-pages/auth/forgot.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/forgot"])
      });
    }
  